import { createFileRoute } from '@tanstack/react-router';
import { FileText } from 'lucide-react';
import { SelectionPlaceholder } from '@/components/molecules';

export const Route = createFileRoute('/_dashboard/dashboard/invoices/')({
  component: InvoicesIndexPage,
});

function InvoicesIndexPage() {
  return (
    <SelectionPlaceholder
      icon={FileText}
      title="Select an invoice"
      iconClassName="h-10 w-10 opacity-30"
      className="flex h-full flex-col items-center justify-center gap-3 text-muted-foreground"
    />
  );
}
